import { useI18n } from "vue-i18n";

export const formatISODate = (date) => {
  const d = new Date(date);

  const utc = new Date(0);
  utc.setUTCFullYear(d.getFullYear());
  utc.setUTCMonth(d.getMonth());
  utc.setUTCDate(d.getDate());

  return utc.toJSON().slice(0, 10);
};

export const todayISODate = formatISODate(new Date());

export const formatDay = (datetime) => {
  const { t } = useI18n();
  const days = [t("Sunday"), t("Monday"), t("Tuesday"), t("Wednesday"), t("Thursday"), t("Friday"), t("Saturday")];
  const day = new Date(datetime).getDay();
  return days[day];
};

export const formatDays = (from, until) => {
  const s1 = formatDay(from);
  const s2 = formatDay(until);

  // Fri - Sun
  if (s1 !== s2) {
    return `${s1}—${s2}`;
  }

  // Sat
  return s1;
};

import __slugify from "slugify";
export const slugify = (str) => __slugify(str, { lower: true, strict: true });

export const capitalize = (str) => str.replace(/[a-z]/i, (ch) => ch.toUpperCase());

import { isoCountry2 as countries } from "@xs2event/js-lib";

export const iso3ToIso2 = (iso3) => {
  return countries.find((c) => c.code3 === iso3)?.code;
};

export function formatDateOfBirth(dateOfBirthISO) {
  const dateOfBirth = new Date(dateOfBirthISO);
  return `${dateOfBirth.getFullYear()}-${String(dateOfBirth.getMonth() + 1).padStart(2, "0")}-${String(dateOfBirth.getDate()).padStart(2, "0")}`;
}
